export const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY ?? '';
export const APP_PROJECT_NAME = 'identification_gateway_frontend';
export const APP_IS_PROD = process.env.TARGET_ENV === 'production';
export const APP_VERSION = process.env.APP_VERSION ?? 'local';
